const SELECTOR = '[data-faateh-box-wrapper]';

function initFaatehBox(wrapper) {
  if (!wrapper || wrapper.dataset.faatehInitialized === 'true') return;
  wrapper.dataset.faatehInitialized = 'true';

  const toggle = wrapper.querySelector('[data-faateh-box-toggle]');
  const customBuyNow = wrapper.querySelector('[data-faateh-buy-now-with-box]');
  const section = wrapper.closest('.shopify-section, dialog');
  const formComponent = wrapper.closest('product-form-component');
  const productButtons = wrapper.closest('.product-form-buttons');
  const priceJson = wrapper.nextElementSibling?.matches('[data-faateh-box-prices]')
    ? wrapper.nextElementSibling
    : section?.querySelector('[data-faateh-box-prices]');

  if (!toggle || !customBuyNow || !section || !formComponent || !productButtons || !priceJson) return;

  const variants = JSON.parse(priceJson.textContent || '[]');
  const productId = String(wrapper.dataset.productId);
  let selected = false;
  let updating = false;

  productButtons.appendChild(customBuyNow);

  const currentVariantId = () => {
    const input = formComponent.querySelector('input[name="id"]');
    return input ? String(input.value) : null;
  };

  const currentQuantity = () => {
    const selector = formComponent.querySelector('quantity-selector-component');
    return Number(selector?.getValue?.()) || Number(formComponent.dataset.quantityDefault) || 1;
  };

  const nativeCheckoutElements = () =>
    Array.from(section.querySelectorAll('shopify-accelerated-checkout, .shopify-payment-button'));

  const update = () => {
    if (updating) return;
    updating = true;

    const variant = variants.find((item) => String(item.id) === currentVariantId());

    if (variant) {
      section
        .querySelectorAll(`product-price[data-product-id="${productId}"] [ref="priceContainer"] .price`)
        .forEach((priceElement) => {
          const required = selected ? variant.withBox : variant.normal;
          if (priceElement.textContent.trim() !== required) priceElement.textContent = required;

          const container = priceElement.closest('[ref="priceContainer"]');
          if (!container) return;

          let label = container.querySelector('.faateh-price-includes-box');
          if (selected && !label) {
            label = document.createElement('span');
            label.className = 'faateh-price-includes-box';
            label.textContent = 'Incl. box';
            container.appendChild(label);
          } else if (!selected) {
            label?.remove();
          }
        });
    }

    nativeCheckoutElements().forEach((element) => {
      element.hidden = selected;
      const parent = element.parentElement;
      if (parent && parent.children.length === 1) parent.hidden = selected;
    });

    customBuyNow.hidden = !selected;
    updating = false;
  };

  toggle.addEventListener('click', () => {
    selected = !selected;
    toggle.setAttribute('aria-pressed', String(selected));
    update();
  });

  customBuyNow.addEventListener('click', async () => {
    const variantId = currentVariantId();
    const boxVariantId = wrapper.dataset.boxVariantId;
    if (!variantId || !boxVariantId) return;

    customBuyNow.disabled = true;
    customBuyNow.textContent = 'Preparing checkout…';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [
            { id: Number(variantId), quantity: currentQuantity() },
            { id: Number(boxVariantId), quantity: 1 }
          ]
        })
      });
      const result = await response.json();
      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || 'Unable to add the product and box.');
      }
      window.location.assign('/checkout');
    } catch (error) {
      console.error('Faateh box checkout error:', error);
      customBuyNow.disabled = false;
      customBuyNow.textContent = 'Buy now with box';
      window.alert('The product or premium box could not be added. Please try again.');
    }
  });

  const observer = new MutationObserver(() => requestAnimationFrame(update));
  const priceRoot = section.querySelector('product-price');
  if (priceRoot) observer.observe(priceRoot, { childList: true, subtree: true });

  section.addEventListener('change', () => requestAnimationFrame(update));
  update();
}

function initAll(root = document) {
  root.querySelectorAll(SELECTOR).forEach(initFaatehBox);
}

initAll();
document.addEventListener('shopify:section:load', (event) => initAll(event.target));
